import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getTemplates } from '../../../api/plan-benefit-override-rules-api'
import type { PlanBenefitOverrideRuleTemplateItemDto } from '../../../api/dto/plan-benefit-override-rules.dto'
import { PlanBenefitOverrideRuleTemplateKey } from '../enums/plan-benefit-override-rule.enum'

export const OVERRIDE_RULE_TEMPLATES_QUERY_KEY = 'overrideRuleTemplates'

const EMPTY_TEMPLATES: PlanBenefitOverrideRuleTemplateItemDto[] = []

export function useGetOverrideRuleTemplates() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [OVERRIDE_RULE_TEMPLATES_QUERY_KEY],
    queryFn: getTemplates,
    staleTime: Infinity,
  })

  const templates = data?.templates ?? EMPTY_TEMPLATES

  const templatesByKey = useMemo(() => {
    const map: Partial<
      Record<
        PlanBenefitOverrideRuleTemplateKey,
        PlanBenefitOverrideRuleTemplateItemDto
      >
    > = {}
    for (const t of templates) {
      map[t.key] = t
    }
    return map
  }, [templates])

  const orderedTemplates = useMemo(
    () => [...templates].sort((a, b) => a.displayOrder - b.displayOrder),
    [templates]
  )

  return {
    templates: orderedTemplates,
    templatesByKey,
    isLoading,
    error,
    refetch,
  }
}
